$(function(){
  var $tooltip = $("<div class='tooltip top in hide'><div class='tooltip-inner'></div></div>").appendTo('body');
  var previousPoint = null;
  var agent = navigator.userAgent.toLowerCase();
  if("ontouchstart" in document && /applewebkit/.test(agent) && /android/.test(agent))
    $('#tasks').on('touchstart', function(e){
    var li = $(e.target).closest('#tasks li');
    if(li.length == 0)return;
    var label = li.find('label.inline').get(0);
    if(label == e.target || $.contains(label, e.target)) e.stopImmediatePropagation() ;
  });

  if($("#map_canvas").length > 0){ init_map("map_canvas", true); }

  $("#login_modal, #password_recover").on("keydown", function(event){
    if(event.keyCode == 13){
	  event.preventDefault();
	  event.stopPropagation();
	  if(login_filled($(this))){ $(this).find("form").submit(); }
  	}
  });

  $('.tag_messages_description').elastic();

});

function login_filled($modal){
  var modal_id = $modal.attr("id");
  switch(modal_id){
    case "login_modal":
      return $("#user_session_email").val().length > 0 && $("#user_session_password").val().length > 0;
    case "password_recover":
      return $("#password_reset_email").val().length > 0;
  }
}